import { CalendarOutlined, FileTextOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import DateFilter from "../../Reuseable/DateFilter/DateFilter";
import NormalButton from "../../Reuseable/NormalButton/NormalButton";
import "./style.scss";

export const ExportDateWiseModal = ({
  loadingExport,
  open = true,
  setOpen,
  data = {},
  handleExport = () => {},
}) => {
  const [params, setParams] = useState({});

  const hasRange = Boolean(params?.start_date && params?.end_date);

  const handleDateChange = (from, to) => {
    if (!from || !to) {
      setParams((prev) => ({ ...prev, start_date: null, end_date: null }));
      return;
    }

    setParams((prev) => ({
      ...prev,
      start_date: dayjs(from).format("YYYY-MM-DD"),
      end_date: dayjs(to).format("YYYY-MM-DD"),
    }));
  };

  const close = () => {
    setOpen(false);
    setParams({});
  };

  /* Inclusive day count, so a single-day range reads as "1 day". */
  const dayCount = hasRange
    ? dayjs(params.end_date).diff(dayjs(params.start_date), "day") + 1
    : 0;

  const readableRange = hasRange
    ? `${dayjs(params.start_date).format("DD MMM YYYY")} — ${dayjs(
        params.end_date,
      ).format("DD MMM YYYY")}`
    : null;

  return (
    <Modal
      title="Export cases"
      centered
      open={open}
      onCancel={close}
      footer={null}
      className="export-modal"
    >
      <div className="exort-cases-modal-wrapper">
        {/* what is being exported - the menu this opens from is per-row */}
        {data?.name && (
          <div className="export-modal__context">
            <span className="export-modal__context-icon">
              <FileTextOutlined />
            </span>
            <span className="export-modal__context-body">
              <span className="export-modal__context-label">Portfolio</span>
              <span className="export-modal__context-name">{data.name}</span>
            </span>
          </div>
        )}

        <div className="export-modal__field">
          <span className="export-modal__label">Date range</span>
          <div className="header-of-export-cases-modal">
            <DateFilter
              onDateChange={handleDateChange}
              isTruncate={false}
              showDate={hasRange}
            />
          </div>
        </div>

        {/* the picked range echoed back, so Export is never a blind click */}
        <div
          className={`export-modal__summary ${hasRange ? "is-set" : ""}`}
          aria-live="polite"
        >
          <CalendarOutlined />
          {hasRange ? (
            <span>
              <strong>{readableRange}</strong>
              <em>
                {dayCount} {dayCount === 1 ? "day" : "days"} of cases
              </em>
            </span>
          ) : (
            <span>
              <strong>No range selected</strong>
              <em>Pick a start and end date to export</em>
            </span>
          )}
        </div>

        <div className="export-modal__foot">
          <button type="button" className="export-modal__cancel" onClick={close}>
            Cancel
          </button>
          <NormalButton
            type="primary"
            disabled={!hasRange}
            loading={loadingExport === data?.id}
            onClick={() => handleExport(params, data)}
          >
            Export
          </NormalButton>
        </div>
      </div>
    </Modal>
  );
};
